"use client";

import { useCallback, useState, useRef } from "react";
import { useController } from "react-hook-form";

const getBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// 출처 : https://stackblitz.com/edit/input-file-react-hook-form?file=src%2FForm.js,src%2FFileController.js,src%2FPickAvatar.js,src%2Futils.js
export const FileController = ({
  name,
  control,
  defaultValue,
  setValue,
  accept,
}: any) => {
  const inputRef = useRef(null);
  const { field } = useController({ name, control });
  const [uploadFile, setUploadFile] = useState(defaultValue?.name);

  const onChange = useCallback(
    async (event: any) => {
      if (event.target.files?.[0]) {
        setUploadFile(await getBase64(event.target.files[0]));
        field.onChange(event.target.files[0]);
      }
    },
    [field]
  );

  const remove = async () => {
    setValue(name, null);
    setUploadFile(null);
  };

  return (
    <>
      <div className="coverUpload-img bg-gray-100">
        {uploadFile ? (
          <div className="coverUpload-list">
            <div className="preview w-200px">
              <div
                className="img"
                style={{
                  backgroundImage: defaultValue?.type.startsWith("image/")
                    ? `url(${uploadFile})`
                    : `url("/assets/images/default_product.png")`,
                }}
              ></div>
              <div className="preview_button">
                <div className="flex">
                  <div className="w-20 text-ellipsis overflow-hidden text-center fw-bold text-white">
                    {defaultValue?.name}
                  </div>
                  <div className="flex flex-row py-1">
                    <button
                      className="btn btn-xs btn-white"
                      type="button"
                      onClick={remove}
                    >
                      <i className="fa fa-trash"></i>
                      {/* 삭제 */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="coverUpload-list">
            <input
              {...{
                type: "file",
                name,
                onChange,
                ref: (instance: any) => {
                  field.ref(instance);
                  inputRef.current = instance;
                },
                accept: accept ?? null,
              }}
              className="hide"
            />

            <button
              type="button"
              className="upload-btn"
              onClick={() => {
                if (inputRef.current) {
                  (inputRef.current as HTMLInputElement)?.click();
                }
              }}
            >
              <i className="fa fa-upload fa-lg"></i>
              <br />
              업로드
            </button>
          </div>
        )}
      </div>

      <div className="coverUpload-box">
        <div className="coverUpload-info">
          <p className="mb-0 fs-10px">파일 : .PNG .JPG</p>
          <p className="mb-0 fs-10px">
            최대크기 : <b>1,000px x 1,000px</b>
          </p>
        </div>
      </div>
    </>
  );
};
